import { apiSlice } from "../apiSlice";

const coachSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCoaching: builder.query({
      query: (coachParams) => ({
        url: `/coach?coach=${coachParams.coach}&message=${coachParams.message}`,
      }),
      keepUnusedDataFor: 5,
    }),
    logStats: builder.mutation({
      query: (data) => ({
        url:  '/coach/stats',
        method: 'POST',
        body: data,
      })
    }),
    logExercise: builder.mutation({
      query: (data) => ({
        url:  '/coach/exercise',
        method: 'POST',
        body: data,
      })
    }),
    addExercise: builder.mutation({
      query: (data) => ({
        url:  '/coach/add',
        method: 'POST',
        body: data,
      })
    }),
    getExercises: builder.query({
      query: () => ({
      url: `/coach/exercise`,
      }),
      keepUnusedDataFor: 5,
    })
  }),
});

export const { useLazyGetCoachingQuery, useLogStatsMutation, useLogExerciseMutation, useAddExerciseMutation, useGetExercisesQuery } = coachSlice;